const btn = document.querySelector(".open-product-content");

btn.addEventListener("click", () => {
  if ((btn.style.webkitLineClamp == "") | (btn.style.webkitLineClamp == 2)) {
    btn.style.webkitLineClamp = "999";
    // btn.style.width = "85vw";
    btn.style.setProperty("--after-collapse-content", "'צמצם'");
  } else {
    btn.style.webkitLineClamp = "2";
    btn.style.whiteSpace = "normal";
    // btn.style.width = "inherit";
    btn.style.setProperty("--after-collapse-content", "'הרחב'");
  }
});

window.addEventListener("resize", () => {
  if (window.screen.width >= 450) {
    btn.style.webkitLineClamp = "999";
    // btn.style.width = "inherit";
    btn.style.setProperty("--after-collapse-content", "'צמצם'");
    return;
  }
  if (window.screen.width < 450) {
    btn.style.webkitLineClamp = "2";
    // btn.style.width = "85vw";
    return;
  }
});
